import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <h3>SAND-Imóveis</h3>
              <p>CRECI: 10965J</p>
              <p className="footer-link">Política de privacidade</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-contact">(47) 98856-9815 | contato@sandimobiliaria.com.br | R. Arthur max doose 183, sala 1902</p>
          <p>&copy; 2025 SAND-Imóveis. Todos os direitos reservados.</p>
          <p>Alugue um lar para chamar de seu</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
